/**
 * Analytics wrapper for codedesign-v2 (dashboard)
 *
 * Sends events directly to PostHog (via proxy) using the posthogAnalytics
 * singleton from @/lib/posthog.  Every event is automatically:
 *   1. Prefixed with "Dashboard:" so the event name is globally unique
 *      (e.g. "Onboarding:Started" → "Dashboard:Onboarding:Started")
 *   2. Tagged with `platform: "dashboard"` as a property for easy filtering
 */

import posthogAnalytics from '@/lib/posthog';

const PLATFORM = 'dashboard';
const PREFIX = 'Dashboard';

/**
 * Track an analytics event.
 * @param {string} eventName  – e.g. "Onboarding:PromptSubmitted"
 *                               → sent as "Dashboard:Onboarding:PromptSubmitted"
 * @param {Object} properties – event-specific key/value pairs
 */
export function trackEvent(eventName, properties = {}) {
  try {
    posthogAnalytics.track(`${PREFIX}:${eventName}`, {
      platform: PLATFORM,
      ...properties,
    });
  } catch (e) {
    // analytics should never crash the app
  }
}


